<template>
  <!-- ケア　オーケストレーター編集 -->
  <div id="CORequestAcceptEdit">
    <div id="container">
      <div class="labelTitle lable">ケア オーケストレーター 申込み受付編集</div>
      <div class="button-area">
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
      <div id="item-contens">
        <!-- 種別：施設登録 -->
        <template v-if="orderType === coOrderType.facilityAdd">
          <div class="card-content margin-top relative">
            <span style="font-size: 20px">{{
              orderType | coOrderTypeFilter()
            }}</span
            ><span v-if="isDealer">（ディーラー申込み）</span>
            <div class="card-content margin-top">
              <table>
                <tr>
                  <th colspan="2">【施設情報】</th>
                </tr>
                <tr>
                  <th>医療機関名<span class="require" /></th>
                  <td>
                    <input
                      type="text"
                      class="edit"
                      name="医療機関名"
                      validate="required"
                      v-model="editData.hospitalName"
                      maxlength="100"
                    />
                  </td>
                </tr>
                <tr>
                  <th>診療科<span class="require" /></th>
                  <td>
                    <input
                      type="text"
                      class="edit"
                      name="診療科"
                      validate="required"
                      v-model="editData.division"
                      maxlength="100"
                    />
                  </td>
                </tr>
                <tr>
                  <th>郵便番号<span class="require" /></th>
                  <td>
                    <input
                      type="text"
                      class="edit"
                      name="郵便番号"
                      validate="required|numeric"
                      v-model="editData.zip"
                      maxlength="7"
                    />
                  </td>
                </tr>
                <tr>
                  <th>都道府県<span class="require" /></th>
                  <td>
                    <input
                      type="text"
                      class="edit"
                      name="都道府県"
                      validate="required"
                      v-model="editData.prefecture"
                      maxlength="20"
                    />
                  </td>
                </tr>
                <tr>
                  <th>市町村<span class="require" /></th>
                  <td>
                    <input
                      type="text"
                      class="edit"
                      name="市町村"
                      validate="required"
                      v-model="editData.city"
                      maxlength="100"
                    />
                  </td>
                </tr>
                <tr>
                  <th>住所1<span class="require" /></th>
                  <td>
                    <input
                      type="text"
                      class="edit"
                      name="住所1"
                      validate="required"
                      v-model="editData.address1"
                      maxlength="100"
                    />
                  </td>
                </tr>
                <tr>
                  <th>住所2</th>
                  <td>
                    <input
                      type="text"
                      name="住所2"
                      v-model="editData.address2"
                      maxlength="100"
                    />
                  </td>
                </tr>
                <tr>
                  <th>電話番号<span class="require" /></th>
                  <td>
                    <input
                      type="text"
                      class="edit"
                      name="電話番号"
                      validate="required|numerichypen"
                      v-model="editData.phoneNumber"
                      maxlength="20"
                    />
                  </td>
                </tr>
                <template v-if="isDealer">
                  <tr>
                    <th>担当支店<span class="require" /></th>
                    <td>
                      <select
                        v-model="branchOfficeCode"
                        class="edit"
                        name="担当支店"
                        validate="required"
                      >
                        <option
                          v-for="branch in branchList"
                          :value="branch.code"
                          :key="branch.code"
                        >
                          {{ branch.name }}
                        </option>
                      </select>
                    </td>
                  </tr>
                </template>
                <tr>
                  <th>クライアント認証<span class="require" /></th>
                  <td>
                    <div class="block">
                      <b-radio
                        class="td_radio"
                        v-model="editData.clientAuthentication"
                        :native-value="true"
                        >有効にする</b-radio
                      >
                      <b-radio
                        class="td_radio"
                        v-model="editData.clientAuthentication"
                        :native-value="false"
                        >有効にしない</b-radio
                      >
                    </div>
                  </td>
                </tr>
                <tr v-if="isDealer">
                  <th>フィリップス保守サービス<span class="require" /></th>
                  <td>
                    <div class="block">
                      <b-radio
                        class="td_radio"
                        v-model="editData.crossReference"
                        :native-value="true"
                        >有</b-radio
                      >
                      <b-radio
                        class="td_radio"
                        v-model="editData.crossReference"
                        :native-value="false"
                        >無</b-radio
                      >
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>備考</th>
                  <td>
                    <textarea
                      v-model="editData.biko"
                      maxlength="256"
                      style="resize: vertical; max-width: 100%"
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="button-area">
            <b-button class="is-primary" v-on:click="updateInstitution"
              >更新</b-button
            >
          </div>
        </template>
        <!-- 種別：ユーザー追加 -->
        <template v-if="orderType === coOrderType.userAdd">
          <div class="card-content margin-top relative">
            <span style="font-size: 20px">{{
              orderType | coOrderTypeFilter()
            }}</span
            ><span v-if="isDealer">（ディーラー申込み）</span>
            <table>
              <tr>
                <th>姓</th>
                <td>{{ userInfo.familyName }}</td>
              </tr>
              <tr>
                <th>名</th>
                <td>{{ userInfo.firstName }}</td>
              </tr>
              <tr v-if="isDealer">
                <th>ユーザー区分<span class="require" /></th>
                <td>
                  <div class="block">
                    <b-radio
                      class="td_radio"
                      name="userType"
                      v-model="editUserClassification"
                      native-value="医療従事者"
                      >医療施設</b-radio
                    >
                    <b-radio
                      class="td_radio"
                      name="userType"
                      v-model="editUserClassification"
                      native-value="ディーラー"
                      >ディーラー</b-radio
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <th>処方設定<span class="require" /></th>
                <td>
                  <div class="block">
                    <b-radio
                      class="td_radio"
                      name="prescription"
                      v-model="editUserInfo.prescriptionSettings"
                      :native-value="true"
                      >操作可</b-radio
                    >
                    <b-radio
                      class="td_radio"
                      name="prescription"
                      v-model="editUserInfo.prescriptionSettings"
                      :native-value="false"
                      >操作不可</b-radio
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <th>メールアドレス<span class="require" /></th>
                <td>
                  <input
                    type="text"
                    v-model="editUserInfo.mail"
                    class="edit"
                    name="ユーザーメールアドレス"
                    validate="required|mail"
                    maxlength="256"
                  />
                </td>
              </tr>
              <tr v-if="!isDealer">
                <th>ケア　エクスポーター<span class="require" /></th>
                <td>
                  <div class="block">
                    <b-radio
                      class="td_radio"
                      v-model="editUserInfo.careExporter"
                      :native-value="true"
                      >利用する</b-radio
                    >
                    <b-radio
                      class="td_radio"
                      v-model="editUserInfo.careExporter"
                      :native-value="false"
                      >利用しない</b-radio
                    >
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="button-area">
            <b-button class="is-primary" v-on:click="updateUser">更新</b-button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { coStatus } from "@/components/mock/base/const.js";
import { coOrderType } from "@/components/mock/base/const.js";

export default {
  name: "CORequestAcceptEdit",
  props: {
    item: Object,
    data: Object,
    userInfo: Object,
    isDealer: Boolean,
    //  ユーザー区分
    userClassification: String,
    searchConditions: Object,
  },
  methods: {
    back: function () {
      this.$router.push({
        name: "CORequestAcceptDetail",
        params: { item: this.item, searchConditions: this.searchConditions },
      });
    },
    updateInstitution: function () {
      // バリデーションチェック
      const elements = document.getElementsByClassName("edit");
      const result = this.selfMadeValidation(elements);
      if (result.isError) {
        this.showErrorMessage(result.msg);
      } else {
        const executeApi = this.updateCoInstitutionPOST;
        const successCallBack = this.updateCoPOSTSuccess;
        const errorCallBack = this.updateCoPOSTError;
        // Web Api Call
        this.apiCall(executeApi, successCallBack, errorCallBack);
      }
    },
    updateCoInstitutionPOST: function (client) {
      const obj = JSON.parse(
        JSON.stringify({
          // 受付番号
          receiptNumber: this.receiptNumber,
          // 医療機関名
          hospitalName: this.editData.hospitalName,
          // 診療科
          division: this.editData.division,
          // 郵便番号
          zip: this.editData.zip,
          // 都道府県
          prefecture: this.editData.prefecture,
          // 市町村
          city: this.editData.city,
          // 住所1
          address1: this.editData.address1,
          // 住所2
          address2: this.editData.address2,
          // 電話番号
          phoneNumber: this.editData.phoneNumber,
          // 支店
          branchOfficeCode: this.branchOfficeCode,
          // クライアント認証
          clientAuthentication: this.editData.clientAuthentication,
          // フィリップス保守サービス
          crossReference: this.editData.crossReference,
          // 備考
          communicationNote: this.editData.biko,
          // 施設ID
          careOrchestratorInstitutionId:
            this.editData.careOrchestratorInstitutionId,
          // バージョン
          version: this.editData.version,
          // ディーラー判別
          isDealer: this.isDealer,
        })
      );
      return client.apis.internalCo.updateCoInstitutionPOST({
        body: obj,
      });
    },
    updateUser: function () {
      // バリデーションチェック
      const elements = document.getElementsByClassName("edit");
      const result = this.selfMadeValidation(elements);
      if (result.isError) {
        this.showErrorMessage(result.msg);
      } else {
        const executeApi = this.updateCoUserPOST;
        const successCallBack = this.updateCoPOSTSuccess;
        const errorCallBack = this.updateCoPOSTError;
        // Web Api Call
        this.apiCall(executeApi, successCallBack, errorCallBack);
      }
    },
    updateCoUserPOST: function (client) {
      const obj = JSON.parse(
        JSON.stringify({
          // ユーザー区分
          userDivision: this.editUserClassification,
          // 処方設定
          prescriptionSettingsValidFlag: this.editUserInfo.prescriptionSettings,
          // メールアドレス
          mail: this.editUserInfo.mail,
          // 受付番号
          receiptNumber: this.receiptNumber,
          // バージョン
          version: this.editData.version,
          // ケア　エクスポーター
          careExporter: this.editUserInfo.careExporter,
          // ディーラー判別
          isDealer: this.isDealer,
        })
      );
      return client.apis.internalCo.updateCoUserPOST({
        body: obj,
      });
    },
    updateCoPOSTSuccess: function (result) {
      this.showSuccess(result);
      this.editMode = false;
      this.back();
    },
    updateCoPOSTError: function (result) {
      this.showErrorMessage(result);
    },
    selectBranch() {
      return this.branchList.map((branch) => {
        if (branch.name === this.data.office) {
          this.branchOfficeCode = branch.code;
        }
      })[0];
    },
  },
  data() {
    return {
      // 支店ユーザーID
      branchUserid: "",
      // 仮パスワード
      provisionalPwd: "",
      // 担当支店
      branchOfficeCode: "",
      // 受付番号
      receiptNumber: this.item.receiptNumber,
      // 申し込み状況
      status: String(this.item.applicationStatus),
      orderType: this.item.kind,
      clientName: this.item.client,
      // 支店一覧
      branchList: this.getBranchOfficeMaster(),
      // データ
      // NOTE: propsで受けた値を直接編集しないために別の変数にコピーする。
      editData: this.data ? { ...this.data } : {},
      // ユーザー情報
      editUserInfo: this.userInfo ? { ...this.userInfo } : {},
      // ユーザー区分
      editUserClassification: this.userClassification
        ? this.userClassification
        : "",
    };
  },
  mounted() {
    this.selectBranch();
  },
  // NOTE: const.jsから参照する以下の値は定数のため、dataには置かずにcomputedプロパティで使用する。
  computed: {
    coStatus() {
      return coStatus;
    },
    coOrderType() {
      return coOrderType;
    },
  },
};
</script>

<style lang="scss" scoped>
.relative {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/careorchestrator/CORequestAcceptEdit.vue